<template>
    <div class="form-group">
        <label>Tapahtuma</label>
        <multiselect
            @select="onSelect"
            :options="audienceOptions"
            :searchable="true"
            track-by="id"
            label="name"
            :options-limit="10"
            :allow-empty="false"
            placeholder="Valitse tapahtumatyyppi"
            selectLabel=""
            deselectLabel=""
            selectedLabel=""
            :show-no-results="false"
            :hide-selected="false"
            :value="selectedAudience">
            <span slot="noResult"></span>
        </multiselect>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect';

    export default {
        model: {
            prop: 'selectedAudience',
            event: 'change'
        },
        components: {
            Multiselect
        },
        props: {
            audienceOptions: {
                type: Array
            },
            selectedAudience: {
                type: Object,
                required: false
            }
        },
        data() {
            return {
                internalSelectedAudience: this.selectedAudience
            };
        },
        methods: {
            onSelect(audience) {
                this.$emit('change', audience);
            }
        }
    };
</script>
